//Section Photo Gallery JS
$(document).ready(function () {

  var galleryCount = 1; // Global variable to keep track of the gallery count

  // Set up initial gallery ID for existing galleries on the page
  $(".gallery").each(function (index) {
    var galleryId = "gallery-" + galleryCount++;
    $(this).attr("id", galleryId);
  });

  //Bring in first image in the gallery to prevent clicking to section no scrolling to correct position if lazy load is on -- Remove this if unneeded.
  $(".gallery__image:first-of-type").each(function () {
    var dataSrc = $(this).attr("data-src");
    $(this).attr("src", dataSrc).removeAttr("data-src");
  });
  //Remove this if unneeded.

  // Find all <a> tags with .gallery__link class inside .gallery__lightboxes
  $(".gallery__link").on("click", function (event) {
    // event.preventDefault(); // Prevent the default behavior of the link

    var $gallery = $(this).closest(".gallery");
    lastClickedGalleryLink = $(this); // Store reference to the clicked .gallery__link

    // Loop through each link within the clicked gallery
    $gallery.find(".gallery__link").each(function (index) {
      var currentHref = $(this).attr("href");

      // Add #lightbox- prefix with an incrementing number
      $(this).attr("href", "#lightbox-" + (index + 1))
        .find('.gallery__image')
        .each(function () {
          var dataSrc = $(this).attr("data-src");
          if (dataSrc) {
            $(this).attr("src", dataSrc).removeAttr("data-src");
          }
        });


      // Check if the corresponding .lightbox element already exists
      if ($("#lightbox-" + (index + 1)).length === 0) {
        // Create a .lightbox element with a matching ID
        var lightbox = $("<div class='lightbox'></div>").attr("id", "lightbox-" + (index + 1));

        // Append the .lightbox element to the body or another container of your choice
        $("body").append(lightbox);

        var linkHTML = $(this).html();
        $("#lightbox-" + (index + 1)).append("<div class='content'>" + linkHTML + "<a class='close' title='Close Image Popup and return to gallery' tabindex='0' href='#gallery'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 384 512'><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c-12.5 12.5-12.5 32.8 0 45.3s12.5 12.5 45.3 0L237.3 256 342.6 150.6z' fill='#ffffff'/></svg></a></div>");
      }

      var dataSrc = $(this).attr("data-src");
      if (dataSrc) {
        $(this).attr("src", dataSrc).removeAttr("data-src");
      }

      // You can add other logic or actions related to each link here
    });

    appendPrevNextButtons();

    // Handle click on .lightbox-next element
    $(".lightbox-next").on("click", function (e) {
      e.preventDefault();
      updateHash(1);
    });

    // Handle Enter Press on .lightbox-next element
    $(".lightbox-next").on("keypress", function (e) {
      if (e.which === 13) {
        e.preventDefault();
        updateHash(1);
      }
    });

    // Handle click on .lightbox-prev element
    $(".lightbox-prev").on("click", function (e) {
      e.preventDefault();
      updateHash(-1);
    });

    // Handle Enter Press on .lightbox-prev element
    $(".lightbox-prev").on("keypress", function (e) {
      if (e.which === 13) {
        e.preventDefault();
        updateHash(-1);
      }
    });

    $(".lightbox .close").on("click", function (e) {
      e.preventDefault();
      $('.lightbox').remove();
      $('.lightbox-pagers').remove();
      // Return focus to the last clicked .gallery__link
      // if (lastClickedGalleryLink) {
      //   lastClickedGalleryLink.focus();
      // }
    });

    $(document).on('keydown', function (e) {
      // Check if the Escape key (key code 27) is pressed
      if (e.which === 27) {
        $('.lightbox').remove();
        $('.lightbox-pagers').remove();
        // Return focus to the last clicked .gallery__link
        // if (lastClickedGalleryLink) {
        //   lastClickedGalleryLink.focus();
        // }
      }
    });

  });

  // Function to update the URL hash
  function updateHash(delta) {
    var currentHash = window.location.hash || "#lightbox-1";
    var match = currentHash.match(/#lightbox-(\d+)/);
    if (match) {
      var number = parseInt(match[1]);
      var maxNumber = $('[id^="lightbox-"]').length; // Count elements with IDs matching #lightbox-
      number += delta;
      if (number > maxNumber) {
        number = 1; // Reset to the first lightbox
      } else if (number < 1) {
        number = maxNumber; // Loop to the last lightbox
      }
      window.location.hash = "#lightbox-" + number;
    }
  }

  //Add previous and next buttons if more than one lightbox exists
  function appendPrevNextButtons() {
    var lightboxElements = $('.lightbox');

    if (lightboxElements.length > 1) {
      var lighboxButtons = $(' <div class="lightbox-pagers"><div class="lightbox-prev" tabindex="0" role="button" aria-label="Go to previous image"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" fill="#000000" /></svg></div><div class="lightbox-next" tabindex="0" role="button" aria-label="Go to next image"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" fill="#000000" /></svg></div></div>');

      // Append the new div to the document, e.g., the body element
      $('body').append(lighboxButtons);
    }
  }

  // Custom function to find focusable elements
  // function findFocusableElements(container) {
  //   return container.find('*').filter(function () {
  //     var tabIndex = $(this).attr('tabindex');
  //     return tabIndex >= 0 || (this.tagName && this.tagName.toLowerCase() === 'a');
  //   });
  // }

  // Find all focusable elements inside .lightbox-pagers and .lightbox
  var focusableElements = findFocusableElements($('.lightbox-pagers, .lightbox'));
  var tabbableElements = focusableElements.filter('[tabindex="0"]');

  if (tabbableElements.length === 0) {
    // If there are no elements with tabindex="0", use all focusable elements
    tabbableElements = focusableElements;
  }

  var firstFocusable = tabbableElements.first();
  var lastFocusable = tabbableElements.last();

  $(document).on('keydown', function (event) {
    if (event.key === 'Tab') {
      if (tabbableElements.length === 0) {
        // If there are no tabbable elements, prevent default behavior
        event.preventDefault();
        return;
      }
      if (event.shiftKey) {
        if (document.activeElement === firstFocusable[0]) {
          lastFocusable.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable[0]) {
          firstFocusable.focus();
          event.preventDefault();
        }
      }
    }
  });

});

$(document).ready(function () {
  // Function to focus on the element with the matching hash in the URL
  function focusOnHashElement() {
    var hash = window.location.hash;
    if (hash) {
      var targetElement = $(hash);
      if (targetElement.length) {
        targetElement.attr('tabindex', '-1').focus(); // Add tabindex and focus
        targetElement.on('blur', function () {
          $(this).removeAttr('tabindex'); // Remove tabindex on blur
        });
      }
    }
  }

  // Call the focusOnHashElement function on page load
  focusOnHashElement();

  // Listen for hash changes (e.g., when clicking anchor links)
  $(window).on('hashchange', focusOnHashElement);

  // Function to check and update the .show-lightbox class
  function checkAndUpdateLightboxClass() {
    if (window.location.hash && window.location.hash.match(/#lightbox-\d+/)) {
      // Add .show-lightbox class to the body tag
      $("body").addClass("show-lightbox");
    } else {
      // Remove .show-lightbox class from the body tag
      $("body").removeClass("show-lightbox");
    }
  }

  // Initial check
  checkAndUpdateLightboxClass();

  // Listen for hashchange event
  $(window).on("hashchange", function () {
    // Check and update the .show-lightbox class
    checkAndUpdateLightboxClass();
  });

});
//Sections Gallery END